import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CompanyInfoPage.PopupDeleteOrganisation', {
    title: 'Delete the Organisation',
    description: 'You are about to delete the Organisation {companyName}.',
    inputLabel: 'Please enter "Delete"',
    inputPlaceholderText: 'Enter "Delete"',
    organisationHasBeenRemoved: 'Organisation has been removed.',
    confirmCheckboxText: 'I understand that the subscription will not be downgraded automatically.',
    delete: 'Delete',
    extendedDescription:
        "Please note: deleting an Organisation <b>does not adjust the subscription</b> automatically. If you don't plan to add another Organisation, please downgrade the subscription manually under the Subscriptions tab.",
});
